import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from 'semantic-ui-react';
import TableLayout from '../../../components/common/Table';
import SearchFilters from '../../../components/elements/SearchFilter';
import { postAsync } from '../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../components/helper/downloadCSVHelper';
import { useLocation } from 'react-router-dom';
import { PageHitCountApi } from '../../../shared/Helper';
import { printTable } from '../../../utils/tableExportUtils';
const PaymentReport = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [datanotfound, setDatanotfound] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [date, setDate] = useState('');
  const [apiData, setApiData] = useState([]);
  const [searchTitle, setSearchTitle] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [next, setNext] = useState(1);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });

  const { t } = useTranslation();
  const dateFormat = moment(date).format('DD/MM/YYYY');
  const { pathname } = useLocation();

  useEffect(() => {
    paymentReportList();
    // GetApplicantName();
  }, []);

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const SearchFilter = {
    projectName: searchTitle || '',
    date: dateFormat || null,
  };

  const columnsData = ['sNo', 'Project Name', 'Donor Name', 'Donor Mobile', 'Amount', 'Date', 'Transaction ID'];

  const displayRecords = apiData?.data?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;
    return (
      <Table.Row key={index}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{data?.m_ProjectName ?? data?.c_ProjectNameByDonor}</Table.Cell>
        <Table.Cell>{data?.m_DonorName ?? data?.c_DonorName}</Table.Cell>
        <Table.Cell>{data?.m_DonorMobile ?? data?.c_DonorMobile}</Table.Cell>
        <Table.Cell>{data?.m_Amount ?? data?.c_Amount}</Table.Cell>
        <Table.Cell>{data?.m_Date ?? data?.c_Date}</Table.Cell>
        <Table.Cell>{data?.m_TransactionID ?? data?.c_TransactionID}</Table.Cell>
      </Table.Row>
    );
  });

  // const paymentReportList = async () => {
  //   setIsLoad(true);
  //   const response = await postAsync(
  //     `Payment/GetPaymentReportFilterList?page=${pageOptions.pageNo}&pageSize=${pageOptions.pageSize}`,
  //     SearchFilter,
  //   );

  //   if (response) {
  //     setIsLoad(false);
  //     setApiData(response);
  //     setPageCount(response.page);
  //     setNext(1);
  //   }
  //   if (response?.statusCode == 204) {
  //     setDatanotfound(true);
  //   }
  // };
  const paymentReportList = async () => {
    try {
      setIsLoad(true);
      const response = await postAsync(
        `Payment/GetPaymentReportFilterList?page=${pageOptions.pageNo}&pageSize=${pageOptions.pageSize}`,
        SearchFilter,
      );

      if (response) {
        setIsLoad(false);
        setApiData(response);
        setPageCount(response.page);
        setDatanotfound(false);
        setNext(1);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (error) {
      setIsLoad(false);
      setDatanotfound(true);
    }
  };
  const changePage = async ({ selected }) => {
    const newPage = selected + 1;
    const apiWithDate = `Payment/GetPaymentReportFilterList?page=${newPage}&pageSize=${pageOptions.pageSize}&projectName=${SearchFilter?.projectName}&date=${SearchFilter?.date}`;
    const apiWithOutDate = `Payment/GetPaymentReportFilterList?page=${newPage}&pageSize=${pageOptions.pageSize}&projectName=${SearchFilter?.projectName}`;
    try {
      setIsLoad(true);
      const response = await postAsync(SearchFilter?.date !== 'Invalid date' ? apiWithDate : apiWithOutDate, {});
      if (response) {
        setIsLoad(false);
        setApiData(response);
        setPageCount(response.page);
        setNext(selected+1);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t(`Something went wrong, Please try again!`));
    }
  };

const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Project Name'),
      accessor: (row) => isActive ? row?.m_ProjectName || row?.c_ProjectNameByDonor  : row?.m_ProjectName || row?.c_ProjectNameByDonor 
    },
     {
      header: t('Donor Name'),
      accessor: (row) => isActive ? row?.m_DonorName || row?.c_DonorName : row?.m_DonorName || row?.c_DonorName
    },   {
      header: t('Donor Mobile'),
      accessor: (row) => isActive ? row?.m_DonorMobile|| row?.c_DonorMobile || 'N/A' : row?.m_DonorMobile|| row?.c_DonorMobile  || 'N/A'
    },   {
      header: t('Amount'),
      accessor: (row) => isActive ? row?.m_Amount || row?.c_Amount  || 'N/A' :row?.m_Amount || row?.c_Amount || 'N/A'
    },
     {
      header: t('Date'),
      accessor: (row) => isActive ? row?.m_Date || row?.c_Date  || 'N/A' : row?.m_Date || row?.c_Date  || 'N/A'
    },
    {
      header: t('Transition ID'),
       accessor: (row) => isActive ? row?.m_TransactionID || row?.c_TransactionID  || 'N/A' : row?.m_TransactionID || row?.c_TransactionID || 'N/A'
    }

  ];
  
  // Call the reusable print function
  printTable({
     data: apiData?.data || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Donation Report')} ${t('list')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};


  // const handlePrint = (e) => {
  //   e.preventDefault();

  //   // Create a container for the table
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Payment Report List')}`;
  //   tableContainer.appendChild(heading);

  //   // Create the table
  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">
  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Donor Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Donor Mobile`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Amount`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Transition ID`)}</th>

  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData?.data
  //       ?.map(
  //         (data, index) => `
  //       <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //         <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.m_ProjectName ?? data?.c_ProjectNameByDonor}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.m_DonorName ?? data?.c_DonorName}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.m_DonorMobile ?? data?.c_DonorMobile}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.m_Amount ?? data?.c_Amount}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.m_Date ?? data?.c_Date}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.m_TransactionID ?? data?.c_TransactionID}</td>

  //       </tr>
  //     `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS for print styling
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {
  //    body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }

  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog after a small delay to ensure styles are applied
  //   setTimeout(() => {
  //     window.print();

  //     // Clean up by removing the table container and style from the DOM
  //     document.body.removeChild(tableContainer);
  //     document.head.removeChild(style);

  //     // Revert display of other elements after printing
  //     setTimeout(() => {
  //       document.querySelectorAll('body > *').forEach((el) => {
  //         el.style.display = 'block';
  //       });
  //     }, 100); // Adjust delay as needed
  //   }, 500); // Adjust delay as needed

  //   return 'success';
  // };
  const handleSearch = async () => {
    setIsLoad(true);
    const apiWithDate = `Payment/GetPaymentReportFilterList?page=${pageOptions.pageNo}&pageSize=${pageOptions.pageSize}&projectName=${SearchFilter?.projectName}&date=${SearchFilter?.date}`;
    const apiWithOutDate = `Payment/GetPaymentReportFilterList?page=${pageOptions.pageNo}&pageSize=${pageOptions.pageSize}&projectName=${SearchFilter?.projectName}`;

    setDatanotfound(false);
    await postAsync(SearchFilter?.date !== 'Invalid date' ? apiWithDate : apiWithOutDate, {})
      .then((response) => {
        setIsLoad(false);
        setApiData(response);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const handleOnExport = () => {
    const filteredData = apiData?.data?.map((item, ii) => ({
      'S.No': ii + 1,
      'Project Name': item.m_ProjectName ?? item?.c_ProjectNameByDonor,
      'Donor Name': item.m_DonorName ?? item?.c_DonorName,
      ' Donor Mobile': item.m_DonorMobile ?? item?.c_DonorMobile,
      ' Amount': item.m_Amount ?? item?.c_Amount,
      Date: item.m_Date ?? item?.c_Date,
      'Transition ID': item.m_TransactionID ?? item?.c_TransactionID,
    }));
    downloadCSV(filteredData, 'Payment Report List');
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row justify-center py-5 mt-3">
          <SearchFilters
            handleSearch={handleSearch}
            setDate={setDate}
            date={date}
            handlePrint={handlePrint}
            handleOnExport={handleOnExport}
            setSearchTitle={setSearchTitle}
            isPayment={true}
            heading={'Donation Report'}
            apiData={apiData}
            isAmount={true}
          />
        </div>
        <div className="row justify-center">
          <TableLayout
            columns={columnsData}
            data={apiData}
            datanotfound={datanotfound}
            pageCount={pageCount}
            changePage={changePage}
            isLoad={isLoad}
            next={next}
            pageOptions={pageOptions}
            displayRecords={displayRecords}
            isAmount={true}
          />
        </div>
      </div>
    </>
  );
};

export default PaymentReport;
